var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "view-all-component" } },
    [
      _c("sticky", [
        _c("div", { staticClass: "clearfix header-panel" }, [
          _c("div", { staticClass: "header" }, [
            _c("span", { staticClass: "notice-header" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$i18n.t("project.viewAll.title")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-btns" },
            [
              _vm.showCreateButton
                ? _c("CreateProject", { staticClass: "create-btn" })
                : _vm._e(),
              _vm._v(" "),
              _vm.canExportSearchResults
                ? _c(
                    "HKLButton",
                    {
                      attrs: { color: "orange" },
                      on: { click: _vm.exportSearchResults },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.exportSearchResults")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.resetFilters()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.resetFilter")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: { id: "query-btn", type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.queryProjects()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.search")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hkld-project-table-container" },
        [
          _c("div", [
            _c("span", { staticClass: "total" }, [
              _vm._v(
                _vm._s(_vm.$t("total")) + ": " + _vm._s(_vm.displayTotalCount)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("CommonTable", {
            ref: "hkld-project-table",
            attrs: {
              tableId: "hkld-project-table",
              renderHeaderList: _vm.itemHeaders,
              tableContentLists: _vm.parsedItems,
              needSearch: true,
              defaultOrder: true,
              yScrollAuto: true,
              getDisplayListLength: _vm.getDisplayListLength,
              defaultOrderKey: _vm.defaultOrderKey,
              orderByDateKeys: ["completedDate", "createdAt"],
              orderByNumberKeys: ["completionPercentage"],
              interactionFunc: _vm.interactionFunc,
              getConditions: _vm.getConditionsCallback,
              enterEvent: _vm.queryProjects,
              getTableOrder: _vm.getTableOrder,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "HKLRemindModal",
        { ref: "remindEmptyModal" },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("hint.emptySearch")) + "\n    "),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }